
import { getCompositionParts, getTechnicalValues } from './values'

const compositionSectionCompareGreaterOrEqual = (type, item, value) => {
  const search = value.split('-')
  const parts = getCompositionParts(item, type)
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].value === value) return true // direct match
    const subject = String(parts[i].value).split('-')
    if (subject.length === 2 &&
      search[0] === subject[0] &&
      Number(search[1]) <= Number(subject[1])) return true
  }
  return false
}

const compositionSectionCompareLowerOrEqual = (type, item, value) => {
  const search = value.split('-')
  const parts = getCompositionParts(item, type)
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].value === value) return true // direct match
    const subject = String(parts[i].value).split('-')
    if (subject.length === 2 &&
      search[0] === subject[0] &&
      Number(search[1]) >= Number(subject[1])) return true
  }
  return false
}

const compositionSectionCompareEqual = (type, item, value) => {
  if(value === null){
    return true
  }
  const search = value.split('-')
  const parts = getCompositionParts(item, type)
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].value === value) return true // direct match
    const subject = String(parts[i].value).split('-')
    if (subject.length === 2 &&
      search[0] === subject[0] &&
      Number(search[1]) === Number(subject[1])) return true
  }
  return false
}

const compositionCompareGreaterOrEqual = (type, item, value) => {
  const parts = getCompositionParts(item, type)
  if (value === null) {
    return parts.length <= 0
  } else {
    for (let i = 0; i < parts.length; i++) {
      if (parts[i].value >= value) {
        return true
      }
    }
  }
  return false
}

const compositionCompareLowerOrEqual = (type, item, value) => {
  const parts = getCompositionParts(item, type)
  if (value === null) {
    return parts.length <= 0
  } else {
    for (let i = 0; i < parts.length; i++) {
      if (parts[i].value <= value) {
        return true
      }
    }
  }
  return false
}

const compositionCompareEqual = (type, item, value) => {
  const parts = getCompositionParts(item, type)
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].value === value) {
      return true
    }
  }
  return false
}


const technicalValueCompareEqual = (type, item, value) => {
  const values = getTechnicalValues(item, type)
  return values.length > 0 && values[0] === value
}

const technicalValueCompareGreaterOrEqual = (type, item, value) => {
  const values = getTechnicalValues(item, type)
  return values.length > 0 && values[0] >= value
}

const technicalValueCompareSmallerOrEqual = (type, item, value) => {
  const values = getTechnicalValues(item, type)
  return values.length > 0 && values[0] <= value
}

export default {

  fireResistanceInner: (item, value) => technicalValueCompareEqual('fireResistanceInner', item, value),
  fireResistanceOuter: (item, value) => technicalValueCompareEqual('fireResistanceOuter', item, value),
  fireBehavior: (item, value) => technicalValueCompareEqual('fireBehavior', item, value),
  heatTransferCoefficient: (item, value) => technicalValueCompareSmallerOrEqual('heatTransferCoefficient', item, value),
  impactSoundLevel: (item, value) => technicalValueCompareSmallerOrEqual('impactSoundLevel', item, value),
  soundReductionIndex: (item, value) => technicalValueCompareGreaterOrEqual('soundReductionIndex', item, value),


  // Exclusiv
  render: (item, value) => compositionCompareEqual('render', item, value),
  
  pinsulation: (item, value) => compositionCompareEqual('pinsulation', item, value),
  outerPlanking: (item, value) => compositionCompareEqual('outerPlanking', item, value),
  innerPlanking1: (item, value) => compositionSectionCompareEqual('innerPlanking1', item, value),
  innerPlanking2: (item, value) => compositionSectionCompareEqual('innerPlanking2', item, value),
  innerPlanking3: (item, value) => compositionSectionCompareEqual('innerPlanking3', item, value),

  // stand: (item, value) => compositionCompareGreaterOrEqual('stand', item, value),
  stand: (item, value) => compositionCompareEqual('stand', item, value),
  
  // <= gefächherdämmung
  compartmentInsulation: (item, value) => compositionSectionCompareLowerOrEqual('compartmentInsulation', item, value),

}
